import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const footerSections = [
  {
    title: '探索',
    links: [
      { label: '首页', path: '/' },
      { label: '风格分类', path: '/categories' },
      { label: '全部文章', path: '/articles' },
      { label: '关于我们', path: '/about' },
    ],
  },
  {
    title: '风格分类',
    links: [
      { label: '野性力量', path: '/categories?tab=yexing-liliang' },
      { label: '优雅叛逆', path: '/categories?tab=youya-panni' },
      { label: '自由灵魂', path: '/categories?tab=ziyou-linghun' },
      { label: '暗夜魅力', path: '/categories?tab=anye-meili' },
      { label: '极简界限', path: '/categories?tab=jijin-jiexian' },
    ],
  },
  {
    title: '品牌信息',
    links: [
      { label: '品牌故事', path: '/about' },
      { label: '联系我们', path: '/about#contact' },
      { label: '用户口碑', path: '/about#testimonials' },
    ],
  },
];

export default function Footer() {
  const navigate = useNavigate();

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, path: string) => {
    e.preventDefault();
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-background-950">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link
              to="/"
              onClick={(e) => handleLinkClick(e, '/')}
              className="font-heading text-2xl font-bold text-background-50 tracking-wide whitespace-nowrap"
            >
              裙子下面是野兽
            </Link>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed max-w-xs">
              探索女性优雅外表之下潜藏的野性力量与自由灵魂。汇聚最具张力的时尚理念、风格宣言与穿搭哲学。
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-200 hover:bg-accent-500 hover:text-background-50 transition-colors duration-300" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-200 hover:bg-accent-500 hover:text-background-50 transition-colors duration-300" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-200 hover:bg-accent-500 hover:text-background-50 transition-colors duration-300" aria-label="小红书">
                <i className="ri-red-packet-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-200 hover:bg-accent-500 hover:text-background-50 transition-colors duration-300" aria-label="Instagram">
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
          </div>

          {footerSections.map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-background-200 tracking-wider uppercase mb-5">
                {section.title}
              </h4>
              <ul className="space-y-3">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      onClick={(e) => handleLinkClick(e, link.path)}
                      className="text-sm text-foreground-400 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 裙子下面是野兽。保留所有权利。
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap">使用条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap">Cookie 设置</a>
          </div>
        </div>
      </div>
    </footer>
  );
}